export interface HasID {
  id: string
}
export type UUID = `${string}-${string}-${string}-${string}-${string}` & {
  __brand: 'UUID'
}

const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isUUID(maybeUUID: unknown): maybeUUID is UUID {
  if (typeof maybeUUID !== 'string') {
    return false
  }

  return uuidRegex.test(maybeUUID)
}

/** A UUID out of somewhere anyone can write in, such as an address. */
export function asUUID(value: string | null | undefined): UUID | null {
  return isUUID(value) ? value : null
}

export interface HasUUID {
  id: UUID
}
